import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setZipDownloadChannel, setZipStatus } from '../filePlayerSlice';

const expect = (value) => {
  if (value == null) throw new Error('internal error');
  return value;
};

const fetchWithTimeout = async (url, options = {}, timeoutMs = 60000) => {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const res = await fetch(url, {
      ...options,
      signal: controller.signal,
    });
    clearTimeout(timeout);
    return res;
  } catch (err) {
    clearTimeout(timeout);
    throw err;
  }
};

const requestDownloadUrl = async (ids) => {
  const res = await fetchWithTimeout('/fm/items/download_zip_file', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ ids }),
  });

  if (!res.ok) throw new Error('Failed to request ZIP URL');
  return res.json();
};

const initiateZipBuild = async (url) => {
  const res = await fetchWithTimeout(url, {
    method: 'POST',
    credentials: 'include',
  });

  if (!res.ok) throw new Error('File uploader setup failed');
  return res.json();
};

export const useZipDownload = () => {
  const dispatch = useDispatch();

  const startZipDownload = useCallback(async ({ checkedItems }) => {
    const ids = Object.keys(checkedItems).filter((id) => checkedItems[id]);
    if (!ids.length) {
      dispatch(setZipStatus({ zipStatus: 'failed' }));
      return;
    }

    dispatch(setZipStatus({ zipStatus: 'building', zipDismissed: false }));

    try {
      const { url } = await requestDownloadUrl(ids);
      const { realtime_updates_channel: channel } = await initiateZipBuild(expect(url));
      dispatch(setZipDownloadChannel(expect(channel)));
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('ZIP download setup failed:', err);
      dispatch(setZipStatus({ zipStatus: 'failed' }));
    }
  }, [dispatch]);

  return { startZipDownload };
};
